export const SECURITY_CONSTANTS = {
  VERIFY_IDENTITY: "To make changes, we want to verify your identity using OTP",
  SEND_TO_PHONE: "Send to phone",
  SEND_TO_EMAIL: "Send to email",
  RECEIVED_PASSCODE: "Received pass code?",
  ENTER_PASSCODE_PHONE: (phone) =>
    `Enter the passcode we have sent to your mobile ending with ${phone?.slice(-4) || "****"}`,
  ENTER_PASSCODE_EMAIL: (email) =>
    `Enter the passcode we have sent to your email (${email || "****@***.com"})`,
  CONTINUE: "Continue",
  RESEND_TEXT: "Didn’t receive the code?",
  RESEND_LINK: "Resend it",
  CHANGE_EMAIL: "email",
  CHANGE_PHONE: "phone",
  CHANGE_PASSWORD: "password"

};